function limpiarTextoParaSlug(texto) {
    return texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') 
      .replace(/[^a-z0-9-]/g, '');
  }
function generateIdFromProducto(producto) {
    return `${producto.nombre}-${producto.categoria}`
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }
const informacionToldos = [
    {
        nombre: 'Toldo Vertical Caída Vertical con Guías',
        categoria: 'Toldos',
        sistema: 'Sistemas Solair®',
        images: [require("../../assets/img/productos/toldos/palilleria.jpg")],
        beneficios: [ 
            'Toldo vertical con guías, ideal para cubrir ventanas, terrazas o porches.',
            'Su estructura sencilla embellece con naturalidad los espacios.',
            'Protege del calor en meses cálidos y del frío en época de invierno, brindando sujeción adicional en espacios sensibles al viento mediante su sistema de guías.',
            'Es una excelente opción para espacios muy expuestos al sol, garantizando comodidad a los usuarios.',
        ],
        instalacion: [ 
            'Puede instalarse desde el techo o sobre la pared.',
            'Su sistema de cables guiado permite sostener la cortina en cualquier posición deseada, ajustando su sistema de frenado.',
            'Disponible con opción de tejadillo, para proteger el sistema de lluvias y suciedad.',
        ],
        cubierta: 'A elegir entre Sunbrella®, Soltis 86, Soltis 92, Soltis W96, Suntex, Vinil Cristal.',
        anchoMaximo: 'Ancho 5.0 m en un solo módulo.',
        alturaMaxima: 'Altura 5.0 metros.',
        garantia: 'Estructura del sistema garantizada por 2 años en ciudad y 1 año frente al mar. Y  Tiempo de producción: 7 días hábiles.'
    },{
        nombre: 'Toldo de brazos invisibles Monoblock',
        categoria: 'Toldos',
        sistema: 'Sistemas Solair®',
        images: [require("../../assets/img/productos/toldos/monoblock.jpg")],
        beneficios: [ 
            'Toldo de brazos invisibles favorito para grandes ventanales, terrazas públicas o patios privados.',
            'El estilo monoblock cuenta con una barra cuadrada entre los soportes que da resistencia adicional, sosteniendo toldos con mayores proyecciones.',
            'Se pueden cubrir zonas más largas colocando varios toldos en serie.',
            'Los brazos están reforzados en el interior para dar mucho mayor resistencia y durabilidad.',
            'Resisten condiciones climáticas exigentes, por ejemplo, en instalaciones frente al mar.',
            'Elija la opción “Pitch” para controlar de manera independiente la inclinación de cada brazo.',
            'Cuenta con opción de “Bambalina Enrollable”, para controlar el sol en horarios donde el sol esté cerca del horizonte y entre por debajo del perfil frontal.',
        ],
        instalacion: [ 
            'Disponible con opción de tejadillo, para proteger el sistema de lluvias y suciedad.',
            'La instalación modular permite cubrir áreas largas con varios toldos.',
        ],
        cubierta: 'A elegir entre Sunbrella®, Soltis 92 y Soltis W96.',
        anchoMaximo: 'Ancho 12.0 m (6.0 en un solo módulo).',
        alturaMaxima: 'Proyección (Std) 2.1 m, 2.6 m, 3.1 m y 3.6 m.',
        garantia: 'Estructura del sistema garantizada por 2 años en ciudad y 1 año frente al mar. Y  Tiempo de producción: 7 días hábiles.'
    },{
        nombre: 'Toldo plano Palillería',
        categoria: 'Toldos',
        sistema: 'Sistemas Solair®',
        images: [require("../../assets/img/productos/toldos/palilleria.jpg")],
        beneficios: [ 
            'La palillería es un toldo formado por guías horizontales (palillos) que corren sobre rieles.',
            'La lona de la cubierta crea elegantes ondas que caracterizan a este sistema.',
            'La palillería es retráctil, por lo que puedes abrir o cerrar de acuerdo a tus necesidades.',
            'Se adapta con mucha facilidad al tamaño de los espacios.',
            'Muy útil para crear verandas o cubrir terrazas, patios, áreas de piscinas y jardines.',
        ],
        instalacion: [ 
            'La estructura se mueve fácilmente sobre rieles, formando las ondas de textil que lo caracterizan.',
            'Permite diferentes tamaños y combinaciones de partes.',
            'La instalación puede realizarse entre paredes, a techo, desde pared (tipo portería) o en pérgola (con 4 postes).'
        ],
        cubierta: 'A elegir entre Sunbrella®, Soltis 92, Soltis W96, Précontraint 502.',
        anchoMaximo: 'Ancho 6.0 m.',
        alturaMaxima: 'Desarrollo 6.0 m.',
        garantia: 'Estructura del sistema garantizada por 2 años en ciudad y 1 año frente al mar. Y  Tiempo de producción: 7 días hábiles.'
    }
].map(producto => ({
    ...producto,
    id: generateIdFromProducto(producto),
    slug: limpiarTextoParaSlug(`${producto.nombre}-${producto.categoria}`),
}));

export default informacionToldos;